import React from "react";

const NewsCard = ({ title, summary, image, link, category, date }) => {
  return (
    <article className="news-card">
      <a href={link} target="_blank" rel="noopener noreferrer">
        <div className="news-image">
          <img src={image} alt={title} />
        </div>
      </a>

      <div className="news-content">
        <div className="news-meta">
          <span className="news-category">{category}</span>
          <span className="news-date">{date}</span>
        </div>

        <h3>{title}</h3>
        <p>{summary}</p>

        <a
          href={link}
          target="_blank"
          rel="noopener noreferrer"
          className="news-link"
        >
          Ver nota completa
        </a>
      </div>
    </article>
  );
};

export default NewsCard;